import React, { useState } from "react"
import { Typography, Upload, message } from "antd"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import { doc, updateDoc, serverTimestamp } from "firebase/firestore"
import { db, storage } from "../../../firebase/config"

const { Link } = Typography

const AddCustomPackingList = ({ record }) => {
  const [uploading, setUploading] = useState(false)

  const handleUpload = async (options) => {
    const { file, onSuccess, onError } = options
    const orderNumber = record.orderNumber // Or however you get the specific order identifier
    const filePath = `orders/${orderNumber}/packingLists/${Date.now()}_${file.name}` // Unique path
    const storageRef = ref(storage, filePath)

    setUploading(true)
    const uploadTask = uploadBytesResumable(storageRef, file)

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Optional: Handle progress updates
        // const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log('Upload is ' + progress + '% done');
      },
      (error) => {
        // Handle unsuccessful uploads
        console.error("Upload failed:", error)
        message.error(`${file.name} file upload failed.`)
        setUploading(false)
        onError(error) // Inform Ant Upload component about the error
      },
      async () => {
        // Handle successful uploads on complete
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          const docRef = doc(db, "orders", record.id)

          await updateDoc(docRef, {
            customPackingList: true,
            customPackingListData: {
              added: serverTimestamp(),
              documentPath: filePath,
              documentDownloadUrl: downloadURL,
              downloaded: false,
              name: file.name, // Store the original filename
            },
            // Optionally update hasPackingList if custom counts as a packing list
            // hasPackingList: true,
          })

          message.success(`${file.name} file uploaded successfully`)
          setUploading(false)
          onSuccess("Ok") // Inform Ant Upload component about success

          // You might need to trigger a data refresh in the parent component here
          // depending on how your data fetching is set up. If `initialData`
          // automatically updates via a listener, this might not be needed.
        } catch (error) {
          console.error("Error updating Firestore or getting download URL:", error)
          message.error("Failed to update order details after upload.")
          setUploading(false)
          onError(error)
        }
      }
    )
  }

  return (
    <Upload
      customRequest={handleUpload}
      showUploadList={false} // Don't show default AntD upload list
      disabled={uploading}>
      <Link loading={uploading}>Add Custom Packing List</Link>
    </Upload>
  )
}

export default AddCustomPackingList
